import uniq from 'lodash/uniq';
/**
 * [getProductRobotImages]
 * Returns an Array of IRobotAsset objects, for use in the PDP page
 *
 * We take the first X(cutoff amount) robot image urls returned and return to the PDP page
 *
 * @param   {Array} robotAssets   Array of robot image urls
 * @param   {number} cutOff returns the first x robots, defaulted to 3
 * @returns {Array}
 */

export const getProductRobotImages = ({ robotAssets = [], cutOff = 3 }) => {
  if (robotAssets.length === 0) return null;

  const robotList = uniq(robotAssets);

  if (cutOff === 0) return robotList;

  return robotList.slice(0, cutOff);
};

export const getRobotProductImagesForCarousel = ({ robotAssets = [], cutOff = 0, name = '' }) => {
  const robotImages = getProductRobotImages({ robotAssets, cutOff });

  if (!robotImages) return [];

  const mutatedRobotImages = [];

  for (const robot of robotImages) {
    mutatedRobotImages.push({
      mainPictureUrl: robot.url,
      altText: `Model wearing ${name}`,
    });

    if (robot.backUrl) {
      mutatedRobotImages.push({
        mainPictureUrl: robot.backUrl,
        altText: `Model wearing ${name} back view`,
      });
    }
    if (robot.webmUrl || robot.movUrl) {
      mutatedRobotImages.push({
        /* include the front robot image to serve as the poster for videos on slow connections */
        altText: `Model wearing ${name}`,
        mainPictureUrl: robot.url,
        ...(robot.webmUrl && { webmUrl: robot.webmUrl }),
        ...(robot.movUrl && { movUrl: robot.movUrl }),
      });
    }
  }

  return [...mutatedRobotImages];
};
